import { Container } from "@mui/material";
import { type MetaFunction } from "react-router";

import { ErrorBoundary as AppErrorBoundary } from "~/components/ErrorBoundary";
import { EventPage } from "~/feature/event/pages/EventPage";
import { resolveInitialMarket } from "~/feature/event/utils/resolveInitialMarket";
import { getEventMeta } from "~/jsonLD/event";
import { loadEventPageData } from "~/loaders/event";

import type { Route } from "./+types/event";

export async function loader({ params, url }: Route.LoaderArgs) {
  const eventData = await loadEventPageData({
    slug: params.slug,
    pageUrl: url.href,
  });

  return {
    ...eventData,
    categorySlug: eventData.category?.slug ?? null,
  };
}

// A thrown data() only reaches the HTTP response through the boundary route's
// headers export — this is what carries the 503's Retry-After out.
export const headers: Route.HeadersFunction = ({
  errorHeaders,
  loaderHeaders,
}) => errorHeaders ?? loaderHeaders;

export const meta: MetaFunction = (metaArgs) => {
  return getEventMeta(metaArgs);
};

export default function Event({ loaderData }: Route.ComponentProps) {
  const marketId = new URL(loaderData.pageUrl).searchParams.get("market");
  const initialMarket = resolveInitialMarket(loaderData.markets, marketId);

  return (
    <Container maxWidth="xl">
      <EventPage
        event={loaderData.event}
        category={loaderData.category}
        markets={loaderData.markets}
        outcomes={loaderData.outcomes}
        initialMarket={initialMarket}
      />
    </Container>
  );
}

export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
  return <AppErrorBoundary error={error} />;
}
